import React from 'react';
import './Services.css';

const Services = () => {
  const services = [

     {
      icon: '/consultoria.jpeg',
      title: 'Consultoria de Obra',
      description: ['Planejamento e acompanhamento de obra para garantir a execução correta e segura de toda a estrutura, hidráulica e casa de bombas da sua piscina.']
    },
    {
      icon: '/limpeza.jpeg',
      title: 'Limpeza Profissional',
      description: ['Ajuste dos parâmetros essenciais da água (como cloro, pH e alcalinidade) e tratamento de limpeza completa deixando a piscina apropriada para banho. Fazemos planos mensais, limpeza única de emergência, consultoria de tratamento e limpeza, além de oferecermos produtos químicos e acessórios.']
    },
    {
      icon: '/deck.jpeg',
      title: 'Deck de Piscina',
      description: [
        "O serviço voltado a deck de piscina inclui o planejamento, instalação e manutenção de áreas elevadas ou niveladas ao redor de piscinas.",
        "3 serviços de deck que realizamos:",
        "1. Lixamento de madeiras em geral;",
        "2. Pintura e revitalização;",
        "3. Recuperação de peças que ainda tem como reaproveitar e substituição das danificadas."
      ]
    },
    {
      icon: '/rejunte.jpeg',
      title: 'Rejunte',
      description: ['Consiste na aplicação de argamassas especiais (épóxi, acrílico e cimentício) para garantir impermeabilização reduzindo a infiltração da água. É uma proteção a mais para evitar o descolamento de azulejos e combate algas dando o acabamento que sua piscina merece.']
    },
    {
      icon: '/pintura.jpeg',
      title: 'Pintura de Piscina de fibra',
      description: ['Restauração de fissuras, remoção de bolhas, preenchimento de imperfeições e pintura nova com tinta ou gelcoat garantindo a cor e qualidade que sua piscina merece!']
    },
    {
      icon: '/maquina.jpeg',
      title: 'Instalação de Máquinários',
      description: ['Instalação de máquinários de piscina e manutenção, seguindo todas as normas de segurança.']
    },
   
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="services-header">
          <h2>Nossos <span className="highlight">Serviços</span></h2>
          <h1>Soluções Técnicas Para Você Não Ter Dor de Cabeça com Piscina.</h1>
          <p>
            Mais do que limpeza, a Brilha Piscina é especialista em instalação, manutenção e equipamentos. Trabalhamos para evitar problemas antes que eles aconteçam, garantindo eficiência, economia e segurança para sua piscina.
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <img src={service.icon} alt={service.title} />
              </div>
              <h3>{service.title}</h3>
              {Array.isArray(service.description) ? (
                service.description.map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))
              ) : (
                <p>{service.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
